import { generateKeys } from '../utils';
export const beetellerDocumentTypes = generateKeys({
    br: {
        label: 'CPF/CNPJ',
        localization: { id: '', defaultMessage: '' },
        options: {
            cpf: {
                label: 'CPF',
                value: 'CPF',
                key: 'CPF',
            },
            cnpj: {
                label: 'CNPJ',
                value: 'CNPJ',
                key: 'CNPJ',
            },
        },
    },
    ar: {
        label: 'CUIL/CUIT',
        localization: { id: '', defaultMessage: '' },
        options: {
            cuil: {
                value: 'CUIL',
                label: 'CUIL',
                key: 'CUIL',
            },
            cuit: {
                value: 'CUIT',
                label: 'CUIT',
                key: 'CUIT',
            },
        },
    },
    cl: {
        label: 'RUT',
        localization: { id: '', defaultMessage: '' },
        options: {
            rut: {
                value: 'RUT',
                label: 'RUT',
                key: 'RUT',
            },
        },
    },
    co: {
        label: 'NIT/CC',
        localization: { id: '', defaultMessage: '' },
        options: {
            nit: {
                value: 'NIT',
                label: 'NIT',
                key: 'NIT',
            },
            cc: {
                value: 'CC',
                label: 'CC (Citizenship Card)',
                key: 'CC',
            },
        },
    },
    ec: {
        label: 'RUC/CE',
        localization: { id: '', defaultMessage: '' },
        options: {
            ruc: {
                value: 'RUC',
                label: 'RUC',
                key: 'RUC',
            },
            ce: {
                value: 'CE',
                label: 'CE (Cédula)',
                key: 'CE',
            },
        },
    },
    mx: {
        label: 'RFC',
        localization: { id: '', defaultMessage: '' },
        options: {
            rfc: {
                value: 'RFC',
                label: 'RFC (Federal Taxpayer Registry)',
                key: 'RFC',
            },
        },
    },
    pe: {
        label: 'ruc',
        localization: { id: '', defaultMessage: '' },
        options: {
            ruc: {
                value: 'RUC',
                label: 'RUC',
                key: 'RUC',
            },
        },
    },
    uy: {
        label: 'RUT/CI',
        localization: { id: '', defaultMessage: '' },
        options: {
            rut: {
                value: 'RUT',
                label: 'RUT',
                key: 'RUT',
            },
            ci: {
                value: 'CI',
                label: 'CI (Identity card)',
                key: 'CI',
            },
        },
    },
});
export const beetellerAccountTypes = generateKeys({
    br: {
        label: 'CACC/SVGS/TRAN',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
            tran: {
                label: 'Transactional account',
                value: 'TRAN',
                key: 'TRAN',
            },
        },
    },
    ar: {
        label: 'CACC/SVGS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
        },
    },
    cl: {
        label: 'CACC/SVGS/RUT/VISTA',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
            rut: {
                label: 'RUT account',
                value: 'RUT',
                key: 'RUT',
            },
            vista: {
                label: 'Vista account',
                value: 'VISTA',
                key: 'VISTA',
            },
        },
    },
    co: {
        label: 'CACC/SVGS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
        },
    },
    ec: {
        label: 'CACC/SVGS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
        },
    },
    mx: {
        label: 'CACC/SVGS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
        },
    },
    pe: {
        label: 'CACC/SVGS/MASTER',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
            master: {
                label: 'Master account',
                value: 'MASTER',
                key: 'MASTER',
            },
        },
    },
    uy: {
        label: 'CACC/SVGS',
        localization: { id: '', defaultMessage: '' },
        options: {
            cacc: {
                label: 'Checking account',
                value: 'CACC',
                key: 'CACC',
            },
            svgs: {
                label: 'Savings account',
                value: 'SVGS',
                key: 'SVGS',
            },
        },
    },
});
